// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardStatisticsOverviewController = function ($scope, DashboardOverview) {
    $scope.stats = {
        data: [],
        charts: {
            totalNetAmount: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.time.format('%b %y')(new Date(d * 60 * 60 * 1000));
                    }
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('.2f')(d);
                    }
                }
            },
            invoices: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.time.format('%b %y')(new Date(d * 60 * 60 * 1000));
                    }
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    }
                }
            },
            activeContracts: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.time.format('%b %y')(new Date(d * 60 * 60 * 1000));
                    }
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    }
                }
            }
        }
    };

    var data = DashboardOverview.query({ months: 6 }, function () {
        var invoicesChartValues = [];
        var activeContractsValues = [];

        var currencyIndexMap = {};
        var currencyIndex = -1;
        var totalNetAmountChartData = [];

        data.sort(function (a, b) { return a.HoursSinceEpoch - b.HoursSinceEpoch; }); // sort asc by timestamp for charts
        for (var i = 0; i < data.length; i++) {
            invoicesChartValues.push([data[i].HoursSinceEpoch, data[i].NumberOfInvoices]);
            activeContractsValues.push([data[i].HoursSinceEpoch, data[i].NumberOfActiveContracts]);

            if (data[i].BilledAmountByCurrency) {
                for (var j = 0; j < data[i].BilledAmountByCurrency.length; j++) {
                    var currency = data[i].BilledAmountByCurrency[j].Item1;
                    if (!(currency in currencyIndexMap)) {
                        currencyIndexMap[currency] = ++currencyIndex;
                    }

                    if (totalNetAmountChartData.length <= currencyIndex) {
                        totalNetAmountChartData.push({ key: currency, values: [] });
                    }

                    totalNetAmountChartData[currencyIndexMap[currency]].values.push([data[i].HoursSinceEpoch, data[i].BilledAmountByCurrency[j].Item2]);
                }
            }
        }

        $scope.stats.data = data.sort(function (a, b) { return b.HoursSinceEpoch - a.HoursSinceEpoch; });  // sort desc by timestamp
        $scope.stats.charts.invoices.data = [{ "key": "Invoices", values: invoicesChartValues }];
        $scope.stats.charts.activeContracts.data = [{ "key": "Active Contracts", values: activeContractsValues }];
        $scope.stats.charts.totalNetAmount.data = totalNetAmountChartData;
    });
};
DashboardStatisticsOverviewController.$inject = ['$scope', 'DashboardOverview'];
